import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as ClassicAlterListMembershipActionMetadataKeys from 'automation-ui-action-features/deprecated/alter-list-membership/ClassicAlterListMembershipActionMetadataKeys';
/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 */
export default class ClassicAlterListMembershipActionMetadata extends Record({
  [ClassicAlterListMembershipActionMetadataKeys.ACTION_TYPE]: ActionTypes.CLASSIC_ALTER_LIST_MEMBERSHIP,
  [ClassicAlterListMembershipActionMetadataKeys.LIST_ID]: null,
  [ClassicAlterListMembershipActionMetadataKeys.SHOULD_ADD]: null
}, 'ClassicAlterListMembershipActionMetadata') {}